import {createAction} from 'redux-act';
import {IFilters} from 'modules/reducers/filters';

export const setFilter = createAction<Partial<IFilters>>();